import React from "react"
import { SecondaryLeftTextRightImageButtonType } from "../../types/mainModulTypes"
import BaseSubheadline from "../common/BaseSubheadline"
import BaseRichtext from "../common/BaseRichtext"
import { API } from "../../constants/constants"
import rainbow from "../../assets/rainbow-people.png"
import PrimaryButton from "../common/PrimaryButton"
import { useNavigate } from "react-router-dom"

export default function SecondaryLeftTextRightImageButton(props: SecondaryLeftTextRightImageButtonType) {
    const navigate = useNavigate()

    return (
        <div className="max-w-content mx-auto px-4 ">
            <div className="flex flex-col-reverse lg:flex-row  gap-8 items-start w-full pb-16">
                <div className="lg:w-[55%] pt-8">
                    <BaseSubheadline label={props.secondaryLeftTextRightImageButtonHeading1} classProps="pb-2" />
                    <BaseRichtext content={props.secondaryLeftTextRightImageButtonText1} classProps="pb-8" />
                    <BaseSubheadline label={props.secondaryLeftTextRightImageButtonHeading2} classProps="pb-2" />
                    <BaseRichtext content={props.secondaryLeftTextRightImageButtonText2} />
                </div>
                <div className="relative sm:w-1/2  md:w-[calc(45%-2rem)]">
                    <img
                        src={API + props.secondaryLeftTextRightImageButtonImage?.url}
                        alt={props.secondaryLeftTextRightImageButtonImage?.description ?? props.secondaryLeftTextRightImageButtonImage?.name}
                        className="aspect-[3/5] object-cover rounded-default"
                    />
                    <div className="absolute top-full -translate-y-1/2 flex w-full justify-center">
                        <PrimaryButton
                            text={props.secondaryLeftTextRightImageButtonText}
                            active={props.secondaryLeftTextRightImageButtonToggle}
                            onClick={() => {
                                if (props.secondaryLeftTextRightImageButtonUrl.includes("https://")) {
                                    window.open(props.secondaryLeftTextRightImageButtonUrl, "_blank")
                                } else {
                                    navigate(props.secondaryLeftTextRightImageButtonUrl)
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
            <img src={rainbow} alt="Regenbogen Icon" className="w-full object-contain" />
        </div>
    )
}
